{
  "Sidebar": {
    "badges": {
      "beta": "Beta"
    },
    "guest": {
      "title": "保存您的工作",
      "description": "免费注册以永久保存您的试卷、聊天记录和设置。",
      "loginButton": "立即登录"
    },
    "actions": {
      "newExamTitle": "创建新试卷",
      "creating": "正在创建...",
      "newExam": "新试卷"
    },
    "examList": {
      "title": "我的试卷",
      "noExams": "未找到试卷。",
      "unnamed": "未命名",
      "unnamedExam": "未命名试卷",
      "loadOlder": "加载更早的试卷"
    },
    "examMenu": {
      "edit": "编辑",
      "addToClass": "添加到班级",
      "delete": "删除"
    },
    "bottomNav": {
      "profile": "个人资料",
      "settings": "设置",
      "feedback": "提供反馈"
    },
    "dialogs": {
      "renameTitle": "编辑试卷",
      "groupTitle": "试卷分组",
      "renameDesc": "编辑试卷信息。",
      "groupDesc": "为此试卷选择班级或分组。",
      "fields": {
        "name": "名称",
        "subject": "科目",
        "topic": "主题",
        "class": "班级",
        "placeholderSelect": "请选择..."
      },
      "save": "保存"
    },
    "alerts": {
      "deleteConfirm": "您确定要删除这份试卷吗？",
      "saveFailed": "保存失败"
    }
  },
  "Settings": {
    "title": "设置",
    "soon": "即将推出",
    "DisplayAndLanguage": {
      "title": "显示与语言",
      "languageLabel": "语言",
      "languageDesc": "选择用户界面的语言。",
      "themeLabel": "外观",
      "themeDesc": "在浅色和深色模式之间切换。"
    },
    "AI": {
      "title": "AI与评分",
      "strictnessLabel": "AI不确定性",
      "strictnessDesc": "决定在何种AI置信度下必须进行人工审查。",
      "strictnessWarning": "警告：在“高自治度”下，您只在AI极度不确定时才进行人工干预...",
      "gradingKindnessLabel": "评分严格度",
      "gradingKindnessDesc": "决定AI应用评分标准的严格程度。宽松在边缘情况下有利于学生；严格则完全遵循评分标准。",
      "gradingKindnessOptions": {
        "lenient": "宽松",
        "balanced": "平衡",
        "strict": "严格"
      }
    },
    "Notifications": {
      "title": "通知",
      "soon": "即将推出",
      "emailLabel": "邮件通知",
      "emailDesc": "接收关于重要事件的邮件通知",
      "browserLabel": "浏览器通知",
      "browserDesc": "直接在浏览器中接收推送通知"
    },
    "About": {
      "title": "关于 Gradias",
      "landingPage": "访问 gradias.ai",
      "support": "帮助与支持",
      "imprint": "法律声明",
      "privacy": "隐私政策"
    },
    "Account": {
      "title": "数据与账户",
      "exportLabel": "导出我的数据",
      "exportDesc": "以 ZIP 格式下载所有上传的试卷和结果",
      "deleteLabel": "删除我的账户",
      "deleteDesc": "不可逆地删除您的数据及所有相关信息"
    }
  },
  "Profile": {
    "title": "个人资料",
    "actions": {
      "cancel": "取消",
      "save": "保存",
      "edit": "编辑"
    },
    "alerts": {
      "saveError": "无法保存个人资料。",
      "generalError": "发生了一个错误。"
    },
    "personal": {
      "firstName": "名字",
      "lastName": "姓氏",
      "name": "姓名",
      "school": "学校",
      "noSchool": "未填写学校",
      "email": "电子邮箱",
      "emailHint": "此处无法修改电子邮箱。",
      "defaultUser": "用户",
      "role": {
        "teacher": "教师",
        "student": "学生"
      }
    },
    "teaching": {
      "subjects": "我的科目"
    },
    "rules": {
      "title": "规则与偏好",
      "description": "保存的偏好设置，助手在聊天、评分以及创建参考答案和评分标准时会遵循这些设置。您可以在这里自行编辑，但如果需要，助手也可以直接在聊天中为您进行调整。",
      "general": "常规",
      "empty": "尚未保存任何规则。",
      "addRule": "添加规则",
      "removeRule": "移除规则",
      "limitReached": "已达上限",
      "limitHint": "每类别最多 {{max}} 条规则",
      "placeholder": "描述规则...",
      "categories": {
        "chat_and_workflow": "聊天与工作流程",
        "grading_and_feedback": "评分与反馈",
        "master_solution_design": "参考答案",
        "grading_scheme_creation": "评分标准"
      },
      "categoryDescs": {
        "chat_and_workflow": "助手在聊天中如何回答并控制工作流程",
        "grading_and_feedback": "如何评估答案以及如何组织反馈语言",
        "master_solution_design": "如何创建参考答案",
        "grading_scheme_creation": "如何构建评分标准"
      },
      "grammar": {
        "alwaysUseFi": "始终使用错误指数 (FI)",
        "alwaysUseFiDesc": "默认使用错误指数，而不是上传的评分方案中检测到的任何语法规则。可按考试单独覆盖此设置。",
        "languageUseRegradeWordCutoff": "自动重新评估语言表达的字词阈值",
        "languageUseRegradeWordCutoffDesc": "编辑学生答案时，一旦更改的字词数达到此数值，相关组的语言表达将自动重新评估（多次小幅编辑会累计）。",
        "contentRegradeWordCutoff": "自动重新评估内容的字词阈值",
        "contentRegradeWordCutoffDesc": "0 = 始终（默认）——任何文本更改都会立即重新评估内容。更高的值会跳过非常小的编辑的自动重新评估。"
      }
    },
    "security": {
      "title": "账户与安全",
      "changePassword": "修改密码",
      "changePasswordDesc": "管理您的账户安全",
      "logout": "退出登录",
      "logoutDesc": "安全退出此设备"
    },
    "badges": {
      "soon": "即将推出"
    }
  },
  "ClassInsights": {
    "overview": "概览",
    "examCount": "考试数量",
    "subjectCount": "科目数量",
    "gradedCount": "已批改",
    "examListTitle": "该班级的考试",
    "noExams": "该班级暂无考试。",
    "loading": "正在加载数据 …",
    "statusGraded": "已批改",
    "statusInProgress": "进行中",
    "unnamedExam": "未命名考试",
    "unknownSubject": "未知科目"
  },
  "Dashboard": {
    "guestMessage": "我是 gradi，您的 AI 试卷批改助手。",
    "greetings": {
      "opt1": "今天我们要批改哪些试卷？",
      "opt2": "让我们来解决这一叠试卷吧。",
      "opt3": "今天有什么安排？",
      "opt4": "今天我能帮您做点什么？",
      "opt5": "很高兴您能来。我们从哪里开始？",
      "opt6": "让我们开始批改吧！"
    },
    "fallbackGreeting": "今天有什么安排？",
    "greetingPrefix": "嗨",
    "inputPlaceholder": "提出一个问题...",
    "dropzoneText": "将文件拖放到此处",
    "actions": {
      "startGrading": {
        "label": "启动试卷批改",
        "prompt": "我想开始一次新的试卷批改。请引导我逐步完成从上传到创建评分标准的过程。"
      },
      "howItWorks": {
        "label": "gradias 是如何工作的？",
        "prompt": "请简明扼要地向我解释 gradias 是如何工作的，以及为了成功完成批改我需要开启哪些步骤。"
      },
      "sampleData": {
        "label": "使用示例数据进行测试",
        "prompt": "我想测试系统，但手头没有自己的试卷。我该如何使用示例试卷进行测试？"
      },
      "taskTypes": {
        "label": "有哪些题型？",
        "prompt": "您目前可以批改哪些类型的题目（例如：主观题、多选题、数学方程）？"
      },
      "privacy": {
        "label": "数据保护与安全",
        "prompt": "gradias 是如何处理数据保护的？我学生上传的试卷会怎么处理？"
      }
    },
    "alerts": {
      "uploadError": "上传文件时出错",
      "noExamId": "不存在 examId"
    },
    "aria": {
      "uploadFiles": "上传文件",
      "submit": "提交",
      "removeFile": "移除文件"
    }
  },
  "ChatInput": {
    "statusLabels": {
      "allComplete": "所有步骤已完成",
      "configRunning": "完成 - 准备继续",
      "readyForConfig": "准备就绪以进行配置",
      "status": "状态",
      "progress": "进度",
      "inProgress": "进行中"
    },
    "steps": {
      "examCreator": {
        "label": "创建试卷",
        "phasePlan": "正在规划试卷",
        "phaseMaterial": "正在生成插图",
        "phaseSource": "正在编写题目",
        "phaseRepair": "正在完成文档"
      },
      "upload": {
        "label": "文件上传"
      },
      "studentAssignment": {
        "label": "学生匹配",
        "activeWait": "等待确认",
        "activeAssign": "分配学生提交的答卷"
      },
      "structure": {
        "label": "试卷结构",
        "active": "正在识别题目"
      },
      "answers": {
        "label": "学生答案",
        "active": "正在处理答案"
      },
      "masterSolution": {
        "label": "参考答案",
        "activeDetect": "正在识别参考答案",
        "activeCreate": "正在生成参考答案",
        "activeComplete": "正在补全参考答案"
      },
      "gradingScheme": {
        "label": "评分标准",
        "activeDetect": "正在识别评分标准",
        "activeCreate": "正在生成评分标准",
        "activeComplete": "正在补全评分标准"
      },
      "grading": {
        "label": "批改",
        "active": "正在批改"
      },
      "summary": {
        "label": "结果总览"
      }
    },
    "badges": {
      "uncertainties": "不确定项",
      "errorRegions": "错误区域",
      "errorSubmissions": "错误提交",
      "documentEncrypted": "文件已加密"
    },
    "ui": {
      "showProgress": "显示批改进度",
      "dropFilesHere": "将文件拖放到此处",
      "uploadFiles": "上传文件",
      "waitUpload": "等待上传完成",
      "sendMessage": "发送消息",
      "privacyNotice": "100% 符合 GDPR 标准。您的数据和学生文档不会用于 AI 训练。",
      "learnMore": "了解更多。"
    },
    "alerts": {
      "uploadError": "上传文件时出错",
      "noExamId": "不存在 examId"
    }
  },
  "TokenInput": {
    "placeholder": "提出一个问题..."
  },
  "Chat": {
    "auth": {
      "login": "登录",
      "register": "注册"
    },
    "loading": {
      "masterSolutions": "正在加载参考答案...",
      "examData": "正在加载试卷数据与图片...",
      "extractingTasks": "正在提取题目... {{finished}}/{{total}}",
      "splitThinkingMessage": "我正在组织分配学生的答卷",
      "structureThinkingMessage": "我正在识别试卷结构",
      "examStructure": "正在加载试卷结构...",
      "pages": "正在加载页面...",
      "summary": "正在加载摘要..."
    },
    "alerts": {
      "errorOccurred": "抱歉，发生错误。请稍后再试。",
      "reportsBlocked": "只有在所有主题目都释放发布，或 AI 置信度超过 {{threshold}}% 时，才能生成 PDF 报告。",
      "noSubmissionsForReports": "未找到包含报告数据的提交。",
      "reportsFailed": "无法创建 PDF 报告。请重试。"
    },
    "sampleExamIntro": "我想使用以下文档批改这份试卷：\n{{lines}}",
    "canvasTitles": {
      "boundingbox": "调整题目区域",
      "msedit": "编辑参考答案 / 评分标准",
      "correction": "批改",
      "summary": "批改摘要",
      "structureeditor": "编辑试卷结构",
      "submissioncheck": "检查页面分配",
      "demoselector": "选择演示",
      "examcreator": "创建试卷",
      "default": "详细视图"
    }
  },
  "Canvas": {
    "common": {
      "resize": "调整大小",
      "toSummaryTitle": "前往总览",
      "backToSummary1": "返回到",
      "backToSummary2": "总览",
      "restore": "还原",
      "fullscreen": "全屏",
      "close": "关闭"
    },
    "grading": {
      "prevTask": "上一题",
      "nextTask": "下一题",
      "taskXofY": "第 {{current}} 题，共 {{total}} 题",
      "taskName": "题目 {{number}}",
      "nextUncertainty": "下一个不确定项 ({{count}})",
      "uncertaintiesLeft": "剩余 {{count}} 个不确定项",
      "backToSummary1": "返回到",
      "backToSummary2": "总览",
      "submissionX": "答卷 {{id}}",
      "pages": "页码：",
      "pageX": "第 {{page}} 页",
      "addBoundingBox": "添加新的边界框",
      "extractedText": "提取的文本",
      "verified": "已验证",
      "consistencyAdjusted": "已根据其他答卷的一致性自动调整",
      "bboxConfidence": "边界框置信度: {{conf}}%",
      "review": "检查",
      "noTextExtracted": "未提取到文本。",
      "imageContent": "图片（无文本识别）- 识别出的图片裁剪区域将直接用于后续处理",
      "aiGrading": "AI 评分",
      "pts": "分",
      "points": "得分：",
      "noGradingYet": "尚无评分。",
      "gradingScheme": "评分标准",
      "expand": "展开",
      "collapse": "折叠",
      "maxPoints": "最高得分: {{points}}",
      "noGradingSchemeYet": "尚无评分标准。",
      "boxModeContent": "内容",
      "boxModeLanguageUse": "语言表达",
      "groupLanguageUseRule": "分组:任务 {{tasks}}",
      "groupLanguageUseRuleNumbered": "分组{{number}}:任务 {{tasks}}",
      "editLanguageUseGroupTasks": "编辑该分组的任务",
      "deleteLanguageUseGroup": "删除此语言表达规则",
      "deleteLanguageUseGroupConfirm": "确定要删除此语言表达规则吗？此操作无法撤销。",
      "deleteLanguageUseGroupBlocked": "评分进行中时无法删除。",
      "languageUseGroupPickerInfo": "勾选任务以将其加入该分组;取消勾选以移除——如果该任务仍需要自己的语言表达规则,系统会用该分组的文本预填并将满分设为0,以便你能再次找到它。",
      "languageUseGroupPickerSaveFailed": "保存失败,请重试。",
      "languageUseGroupPickerEmptyDraft": "一条规则至少需要一个任务。",
      "deleteBox": "删除边界框",
      "retryOcr": "重试文字识别",
      "unlockBox": "解锁边界框",
      "lockBox": "锁定边界框",
      "noSubmissionsFound": "未找到提交的答卷。",
      "examPageX": "试卷第 {{page}} 页",
      "rerunningOcr": "正在重新识别文字...",
      "regrading": "正在重新评分...",
      "regradingQueued": "排队中..."
    },
    "msgs": {
      "noTasksFound": "未找到题目。",
      "prevTask": "上一题",
      "nextTask": "下一题",
      "task": "题目",
      "taskMain": "题目 {{main}}",
      "taskSub": "题目 {{main}}.{{sub}}",
      "uncertaintiesLeft": "剩余 {{count}} 个不确定项",
      "nextUncertainty": "下一个不确定项 ({{count}})",
      "taskExcerpt": "题目片段",
      "noImageAvailable": "无可用图片...",
      "masterSolution": "参考答案",
      "aiGeneratedProposalTooltip": "由 AI 生成的建议",
      "aiGeneratedProposal": "AI 生成的建议",
      "review": "检查",
      "approvalRequiresPoints": "只有当分数大于 0 时才能确认。",
      "saveRequiresPoints": "只有当分数大于 0 时才能保存。",
      "enterMasterSolution": "在此处输入参考答案...",
      "noMasterSolutionYet": "尚无参考答案...",
      "gradingScheme": "评分标准",
      "maxPoints": "满分分值",
      "maxPointsValue": "最高得分: {{points}}",
      "enterGradingScheme": "在此处输入评分标准...",
      "noGradingSchemeYet": "尚无评分标准...",
      "gradingSchemeRefining": "正在更新评分标准...",
      "masterSolutionRefining": "正在更新参考答案..."
    },
    "submissionCheck": {
      "pageShort": "第 {{page}} 页",
      "zoomPage": "放大第 {{page}} 页",
      "pageAlt": "页面",
      "loading": "正在加载...",
      "newStudent": "新学生",
      "readOnly": "只读",
      "saveAssignment": "保存分配",
      "unassignedPagesTitle": "需澄清：未分派的页面 ({{count}})",
      "unassignedPagesHint": "请将这些页面拖入相应学生的文件夹中。",
      "newStudentIndexed": "新学生 {{index}}",
      "studentIndexed": "学生 {{index}}",
      "enterName": "输入姓名...",
      "pageX_one": "{{count}} 页",
      "pageX_other": "{{count}} 页",
      "splitConfidenceHover": "拆分置信度: {{percent}}%",
      "splitPercent": "拆分 {{percent}}%",
      "deleteStudent": "删除学生",
      "dragHint": "将文档拖放到此处以分配给 {{name}}",
      "assignmentNotes": "分配提示",
      "previewPageAlt": "预览第 {{page}} 页",
      "pageCurrentOfTotal": "第 {{current}} 页，共 {{total}} 页",
      "locked": "已确认",
      "lockedHint": "已确认 – 无法再进行编辑。"
    },
    "summary": {
      "studentsOverview": "每位学生摘要",
      "studentsOverviewDesc": "每道题目的详细得分和 AI 评分",
      "searchStudent": "搜索学生姓名...",
      "student": "学生",
      "pointsAbbr": "分",
      "total": "总计",
      "percentage": "百分比",
      "grade": "成绩/等级",
      "noHits": "无匹配项。",
      "aiConfidenceHover": "AI 置信度: {{percent}}% - 请手动检查",
      "aiUncertainties": "AI 不确定项",
      "aiUncertaintiesDesc": "检查 AI 不确定的案例，以确保公平评分。",
      "openDecisions": "{{count}} 项待决定的决策",
      "sortBy": "排序方式",
      "task": "题目",
      "aiUncertainty": "AI 不确定性",
      "confidence": "AI 置信度：",
      "points": "得分：",
      "toGrading": "前往评分",
      "confirmed": "已确认",
      "confirm": "确认",
      "noClarificationNeeded": "无需澄清。",
      "worstAvg": "最差平均分",
      "noDataYet": "尚无数据",
      "avgSuffix": "平均",
      "frequentErrors": "最常见错误来源",
      "metricsPerTask": "每题指标",
      "gradeDistribution": "成绩分布图",
      "count": "数量",
      "pdfReports": "PDF 报告",
      "downloadingPdf": "正在创建 PDF 报告...",
      "downloadPdf": "下载 PDF 报告",
      "csvExport": "CSV 成绩导出",
      "notConnected": "尚未连接",
      "notMet": "未达到",
      "downloadingCsv": "正在创建 CSV...",
      "downloadCsv": "下载 CSV",
      "gradeScale": "评分分级系统",
      "gradeFrom": "成绩 {{grade}} 分数线为",
      "normalDistribution": "正态分布 (高斯曲线)",
      "activated": "已启用",
      "deactivated": "已禁用",
      "curveStrength": "曲线调整强度",
      "curvingComingSoon": "曲线调整功能尚未上线，敬请期待。",
      "noSubmissionsFound": "未找到已批改的答卷。",
      "avgPointsReached": "Ø 平均获得分数",
      "pointsReached": "获得分数",
      "gradeSystem": "评分系统",
      "gradeBorders": "分数界限",
      "lowestGradeLabel": "最低成绩 (0%起)",
      "tabs": {
        "students": "学生总览",
        "clarification": "需澄清事项",
        "insights": "题目洞察",
        "grades": "成绩分布图",
        "curving": "评分分级与调分",
        "export": "导出",
        "languageUse": "语言表达 & 语法"
      },
      "gradingScales": {
        "german16": "德国 (1–6)",
        "drittel": "三分制 (1.0–5.0)",
        "af": "A–F",
        "gpa4": "4.0 GPA",
        "notenpunkte": "分数点 (0–15)",
        "numeric10": "10分制",
        "percentage": "百分比",
        "custom": "自定义"
      },
      "grammar": "语法",
      "fehlerindex": "错误指数 (FI)",
      "grammarFiColumnHint": "仅包含仍通过错误指数评分的任务；基于规则评分的任务有各自独立的列。",
      "taskLanguageUseColumn": "{{label}} · 语言表达",
      "grammarTab": {
        "noGrammarTasks": "本试卷不包含带语法评估的题目。",
        "fiTitle": "错误指数扣分",
        "fiDesc": "错误指数 = 每 100 个单词的错误数。超过阈值时，总成绩将按等级档次下调。",
        "fiUnsupportedScale": "百分比评分制不支持按等级档次扣分。",
        "fiAbove": "当错误指数超过",
        "deductSteps": "扣除（等级档次）",
        "matrixTitle": "每位学生及题目的语法错误",
        "matrixDesc": "错误数量（括号内为错误指数）。点击单元格可在语法模式下打开批改。",
        "fiSwitchTitle": "对本次考试应用错误指数",
        "fiSwitchDesc": "默认使用你的个人资料设置；开启后仅针对本次考试覆盖该设置。",
        "gradeWithFi": "成绩（含FI）"
      },
      "languageUseTab": {
        "rulesOverviewTitle": "评分中使用的语言表达规则",
        "ownRuleEntry": "{{label}}：自有规则（{{points}} 分）",
        "groupRuleEntry": "{{label}}（{{points}} 分）",
        "teacherRulesActive": "语言表达将根据你的个人规则在评分时直接考虑。错误指数扣分已停用。"
      }
    },
    "structureEditor": {
      "pointsInconsistent": "分数不一致。在每一层级，要么给所有任务都分配分数（其总和等于上级任务的总分），要么全部留空。请修正高亮显示的任务：",
      "pointsInconsistentTask": "任务 {{path}} 缺少分数",
      "totalPoints": "总分（含子任务）",
      "ownPoints": "自身分数（该任务自身作答部分）",
      "tasksWithoutRegion": "无标记区域的任务",
      "noPages": "没有可用页面。",
      "taskAreasDetected_one": "识别出 {{count}} 个题目区域",
      "taskAreasDetected_other": "识别出 {{count}} 个题目区域",
      "addArea": "添加区域",
      "remove": "移除",
      "resetZoom": "重置缩放",
      "readOnly": "只读",
      "saving": "正在保存...",
      "saved": "已保存",
      "blankExamPage": "空白试卷第 {{page}} 页",
      "deleteBbx": "删除 BBX",
      "retryOcr": "重试文字识别",
      "noTasksOnPage": "此页面上没有题目",
      "task": "题目",
      "noText": "没有文本",
      "imageContent": "图片（无文本识别）- 识别出的图片裁剪区域将直接用于后续处理",
      "additionalInfo": "附加信息",
      "noContent": "无内容",
      "linkedTasks": "关联的题目",
      "noTasks": "没有题目"
    },
    "demoSelector": {
      "title": "选择演示",
      "description": "选择一份示例试卷。gradias 将模拟上传过程并自动开始提取。",
      "examCount_one": "{{count}} 份试卷",
      "examCount_other": "{{count}} 份试卷",
      "studentCount_one": "{{count}} 名学生",
      "studentCount_other": "{{count}} 名学生",
      "examLanguage": "试卷语言",
      "subjects": {
        "math": "数学",
        "english": "英语",
        "technical": "职业学校",
        "biology": "生物",
        "spanish": "西班牙语",
        "french": "法语",
        "physics": "物理",
        "political_education": "政治教育",
        "german": "德语"
      },
      "grades": {
        "gesamtschule": "综合中学",
        "highSchool": "高级中学",
        "elementarySchool": "小学",
        "vocationalSchool": "成人教育",
        "middleSchool": "初级中学",
        "university": "大学",
        "primarySchool": "小学"
      },
      "exams": {
        "kaarst": {
          "name": "数学 GK 曲线讨论",
          "description": "完整数据集：学生答卷、参考答案、评分标准和空白试卷"
        },
        "arne": {
          "name": "数学 6年级 分数",
          "description": "学生答卷"
        },
        "lynehamMath": {
          "name": "数学",
          "description": "学生答卷"
        },
        "tuevBauleiter": {
          "name": "施工员",
          "description": "学生答卷和参考答案"
        },
        "tuvPhotovoltaik": {
          "name": "光伏",
          "description": "学生答卷和参考答案"
        },
        "engVocabulary": {
          "name": "词汇测试 (英语)",
          "description": "完整数据集：学生答卷、参考答案、评分标准和空白试卷"
        },
        "bioImageLabeling": {
          "name": "图片标注 (生物)",
          "description": "完整数据集：学生答卷、参考答案和空白试卷"
        },
        "mathProofFr": {
          "name": "数学证明",
          "description": "完整数据集：学生答卷、参考答案和空白试卷"
        },
        "mathProofEng": {
          "name": "数学证明",
          "description": "完整数据集：学生答卷、参考答案和空白试卷"
        },
        "plotting": {
          "name": "绘制函数图像",
          "description": "完整数据集：学生答卷、参考答案和空白试卷"
        },
        "curveAnalysis": {
          "name": "曲线讨论",
          "description": "完整数据集：学生答卷、参考答案和空白试卷"
        },
        "calculationDe": {
          "name": "物理",
          "description": "完整数据集：学生答卷、参考答案、评分标准和空白试卷"
        },
        "dictationFr": {
          "name": "听写 — 法语",
          "description": "完整数据集：学生答卷、参考答案、评分标准和空白试卷"
        },
        "dictationEs": {
          "name": "听写 — 西班牙语",
          "description": "完整数据集：学生答卷、参考答案、评分标准和空白试卷"
        },
        "calculationFr": {
          "name": "计算题",
          "description": "完整数据集：学生答卷、参考答案、评分标准和空白试卷"
        },
        "calculationEs": {
          "name": "计算题",
          "description": "完整数据集：学生答卷、参考答案、评分标准和空白试卷"
        },
        "calculationEn": {
          "name": "计算题",
          "description": "完整数据集：学生答卷、参考答案、评分标准和空白试卷"
        },
        "multipleChoiceDe": {
          "name": "多项选择",
          "description": "完整数据集：学生答卷、参考答案、评分标准和空白试卷"
        },
        "multipleChoiceEn": {
          "name": "多项选择",
          "description": "完整数据集：学生答卷、参考答案、评分标准和空白试卷"
        },
        "multipleChoiceFr": {
          "name": "多项选择",
          "description": "完整数据集：学生答卷、参考答案、评分标准和空白试卷"
        },
        "multipleChoiceEs": {
          "name": "多项选择",
          "description": "完整数据集：学生答卷、参考答案、评分标准和空白试卷"
        },
        "politics12German": {
          "name": "政治教育 — 12年级",
          "description": "完整数据集：学生答卷、参考答案、评分标准和空白试卷"
        },
        "poetry12German": {
          "name": "诗歌分析 — 12年级",
          "description": "完整数据集：学生答卷、参考答案、评分标准和空白试卷"
        },
        "poetry12English": {
          "name": "诗歌分析 — 12年级",
          "description": "完整数据集：学生答卷、参考答案、评分标准和空白试卷"
        },
        "poetry12French": {
          "name": "诗歌分析 — 12年级",
          "description": "完整数据集：学生答卷、参考答案、评分标准和空白试卷"
        },
        "materialBasedEnglish": {
          "name": "基于材料的写作",
          "description": "完整数据集：学生答卷、参考答案、评分标准和空白试卷"
        },
        "materialBasedGerman": {
          "name": "基于材料的写作",
          "description": "完整数据集：学生答卷、参考答案、评分标准和空白试卷"
        }
      }
    },
    "examEditor": {
      "savingAndRecompiling": "正在保存并重新编译…",
      "unsavedChanges": "未保存的更改",
      "allChangesSaved": "所有更改已保存",
      "readOnlyBanner": "此试卷已锁定：已存在标准答案、评分方案或学生提交的答卷，因此此处无法再进行更改。",
      "generatingExam": "正在生成试卷…",
      "refiningExam": "正在更新试卷…",
      "downloadPdf": "下载 PDF",
      "preparingPdf": "正在准备 PDF…",
      "notSaved": "未保存：{{message}}",
      "seeProblemsBelow": "见下方问题",
      "noExam": "没有试卷。",
      "noSourceYet": "此试卷尚无源文件。",
      "noPreviewYet": "尚无已编译的预览 — 点击任意区块或标记点即可编辑并生成一个。",
      "tellAiPlaceholder": "告诉 AI 需要更改的内容……",
      "delete": "删除",
      "applying": "正在应用……",
      "send": "发送",
      "done": "完成",
      "describeAiPlaceholder": "向 AI 描述要在此处添加的任务……",
      "add": "添加",
      "adding": "正在添加……",
      "task": "题目 {{number}}",
      "taskNumber": "题号",
      "type": "类型",
      "points": "分数",
      "lines": "行数",
      "taskText": "题目文本",
      "material": "材料",
      "title": "标题",
      "usedByTasks": "被以下题目使用（用逗号分隔的编号）",
      "text": "文本",
      "multipleChoice": "多项选择",
      "removeOption": "删除选项",
      "addOption": "+ 添加选项",
      "figureProperties": "图片属性",
      "caption": "图注",
      "examSetup": "试卷设置",
      "subject": "科目",
      "class": "班级",
      "duration": "时长",
      "totalPoints": "总分",
      "globalHints": "总体提示 / 说明",
      "studentView": "在线作答"
    }
  },
  "TaskTypeDescs": {
    "taskFrame": "对子题目进行分组，不需要单独回答",
    "default": "通用题目类型（在没有其他类型匹配时使用）",
    "shortText": "简短的书面回答（几句话）",
    "essay": "较长的、结构化的连贯文本",
    "diagram": "技术图纸，例如流程图或电路图",
    "sketch": "徒手画或草图",
    "gapText": "填写文本挖空部分（填空题）",
    "labelImage": "标记图片或图表的某些部分",
    "multipleChoice": "从给定的选项中进行选择",
    "imageAnalysis": "描述或解读图片",
    "mapping": "连接匹配的对象/备选项",
    "legalCase": "法律案例（鉴定报告风格）",
    "calculation": "数学或物理计算",
    "mathematicalProof": "正式的数学证明",
    "curveAnalysis": "曲线讨论（零点、极值等）",
    "plotting": "在坐标系中画出函数、图像或点",
    "geometry": "几何结构作图或计算（绘图）",
    "programming": "编写或分析源代码",
    "art": "创作艺术品或进行艺术设计",
    "dictation": "写下听写文本",
    "translation": "将文本或单词翻译成另一种语言",
    "chemicalFormula": "化学反应方程式或化学式",
    "music": "阅读或编写乐谱",
    "literaryAnalysisPoetry": "分析一首诗",
    "analysisNonFiction": "分析一篇非虚构文本",
    "materialBasedEssay": "根据所提供的材料撰写文章"
  },
  "TaskTypes": {
    "taskFrame": "任务框架",
    "default": "标准",
    "shortText": "短文本",
    "essay": "小论文",
    "diagram": "图表",
    "sketch": "草图",
    "gapText": "填空题",
    "labelImage": "图片标记",
    "multipleChoice": "多项选择",
    "imageAnalysis": "图像分析",
    "mapping": "匹配关联",
    "legalCase": "法律案例",
    "calculation": "计算题",
    "mathematicalProof": "数学证明",
    "curveAnalysis": "曲线讨论",
    "plotting": "绘制图像",
    "geometry": "几何",
    "programming": "编程",
    "art": "艺术",
    "dictation": "听写",
    "translation": "翻译",
    "chemicalFormula": "化学式",
    "music": "音乐",
    "literaryAnalysisPoetry": "诗歌分析",
    "analysisNonFiction": "非虚构文本分析",
    "materialBasedEssay": "基于材料的写作"
  },
  "GapText": {
    "gap": "空格",
    "correct": "正确",
    "incorrect": "错误",
    "empty": "空白",
    "points": "得分",
    "expectedAnswer": "期望答案",
    "studentAnswer": "学生答案",
    "status": "状态"
  },
  "progress": {
    "analyzingSplit": "正在分析拆分",
    "extractingAnswers": "正在提取学生答案...",
    "errorExtractingAnswers": "提取学生答案时出错",
    "answersExtracted": "学生答案已提取",
    "extractingMasterSolution": "正在提取参考答案内容",
    "errorStructureMasterSolution": "创建题目结构时出错 (参考答案)",
    "errorExtractingMasterSolution": "提取参考答案时出错",
    "masterSolutionExtracted": "参考答案已提取",
    "extractingGradingScheme": "正在提取评分标准",
    "errorStructureGradingScheme": "创建题目结构时出错 (评分标准)",
    "errorExtractingGradingScheme": "提取评分标准时出错",
    "gradingSchemeExtracted": "评分标准已提取",
    "noUsableMasterSolution": "未识别出可用的参考答案内容。请检查文件或调整分配。",
    "noUsableGradingScheme": "未识别出可用的评分标准。请检查文件或调整分配。",
    "analyzingStructure": "正在分析试卷结构",
    "noSubmissions": "没有可用的提交",
    "errorStructureAnalysis": "试卷结构分析出错",
    "noTasksInStructure": "结构分析中未找到题目",
    "extractingTaskDescriptions": "正在提取题目描述",
    "errorTaskDescriptions": "提取题目描述时出错",
    "taskDescriptionsExtracted": "题目描述已提取",
    "taskStructureCreated": "题目结构已创建",
    "waitingForStructureConfirmation": "等待用户确认试卷结构",
    "structureConfirmed": "试卷结构已确认",
    "structureConfirmationTimeout": "试卷结构确认已超时",
    "errorWaitingStructureConfirmation": "等待试卷结构确认时出错",
    "errorProcessingStructureConfirmation": "处理试卷结构确认时出错",
    "errorCreatingTaskStructure": "创建题目结构时出错",
    "pipelineFailedPrematurely": "流水线提前失败",
    "assignmentConfirmed": "分派已确认",
    "gradingRunning": "评分运行中...",
    "gradingTaskX": "正在评分题目 {{taskNumber}} ...",
    "gradingCompleted": "评分已完成",
    "gradingTaskXCompleted": "题目 {{taskNumber}} 的评分已完成"
  },
  "upload": {
    "noExamId": "未找到试卷 ID",
    "noFileSelected": "未选择文件",
    "processingFailed": "无法处理文件",
    "invalidFileType": "无效的文件类型。请选择 PNG 或 PDF 文件。",
    "uploadError": "上传文件时出错",
    "studentName": "学生 {{index}}",
    "noExamIdForReupload": "错误：不存在用于重新上传的试卷 ID。",
    "reuploadCancelled": "系统信息：重新上传取消已处理。",
    "reuploadCancelFailed": "系统信息：重新上传取消无法完全处理。",
    "filesMissing": "系统拦截：在上传存储中未找到以下文件：{{files}}。请确保文件名与上传的文件完全一致。",
    "assignmentMismatch": "系统拦截：以下文件分配与最后的建议不符。请调用 send_assignment_confirmation_message 并向用户确认新的分配。\n{{lines}}",
    "reuploadStarted": "文件的重新上传已在后台启动。{{extra}}",
    "splitStarted": "学生答卷的拆分已启动。",
    "assignmentProposalSent": "已发送带有分配建议的消息。",
    "assignmentConfirmationMessage": "我对文件分配还不确定，请您快速检查一下。\n\n请在拖放区域确认建议的分配是否正确，或在其中进行调整。之后我可以直接继续。",
    "assignmentProposalFallback": "请检查我的分配建议并确认文件分配。",
    "categorySubmissions": "学生答卷",
    "categoryMasterSolution": "参考答案",
    "categoryGradingScheme": "评分标准",
    "categoryBlankExam": "空白试卷",
    "lowConfidenceListFormat": "'{{file}}'（计划作为 {{category}}）",
    "mismatchFormat": "- {{name}}：上次建议为 \"{{proposed}}\"，当前传入为 \"{{supplied}}\""
  },
  "splitIssues": {
    "unknownStudent": "未知学生",
    "studentNumber": "学生 {{number}}",
    "pageAssignmentError": "并非每个页面都恰好被分配了一次",
    "nonConsecutive": "为 {{names}} 分配了不连续的页面（已被智能体重新排序）",
    "uncertainty": "{{names}} 处存在不确定性",
    "outlierLongExtremeSingle": "{{names}} 的提交特别长",
    "outlierLongExtremePlural": "{{names}} 的提交特别长",
    "outlierShortExtremeSingle": "{{names}} 的提交特别短",
    "outlierShortExtremePlural": "{{names}} 的提交特别短",
    "outlierLongSingle": "{{names}} 的提交异常长",
    "outlierLongPlural": "{{names}} 的提交异常长",
    "outlierShortSingle": "{{names}} 的提交异常短",
    "outlierShortPlural": "{{names}} 的提交异常短",
    "missingStudentNameSingle": "{{totalCount}} 名学生中有 {{missingCount}} 名学生无法提取姓名",
    "missingStudentNamePlural": "{{totalCount}} 名学生中有 {{missingCount}} 名学生无法提取姓名",
    "splitAgentFailure": "拆分智能体错误 {{suffix}}",
    "errorPrefix": "错误",
    "warningPrefix": "警告",
    "parseErrorFallback": "无法处理数据。请检查画布中的分配。",
    "commandError": "我找到了 {{count}} 名学生，每人有 {{range}} 页，但在自动分配页面时出现问题：\n{{problem}}\n\n请在分派画布中检查分配，并在需要时手动更正。完成后，请在聊天中或通过按钮确认，以便我们继续。",
    "messageWarning": "我找到了 {{count}} 名学生，每人有 {{range}} 页，但有以下提示：\n{{problem}}\n\n如果愿意，您可以在分配画布中检查这些提示。否则直接确认即可，以便我们继续。",
    "messageSuccess": "我找到了 {{count}} 名学生，每人有 {{range}} 页。分配非常明确。所有学生都成功提取了姓名。请确认，以便我们继续。",
    "confirmationRequested": "已请求拆分确认",
    "splitAgentFailed": "自动分配学生答卷失败。请稍后重试上传。"
  },
  "structureIssues": {
    "pointsExplanation": "\n\n**关于分数：** 我为部分任务检测到了分数。如果你上传带有分值的评分方案（或已上传），分数将以其为准；此时你可以忽略画布中的分数。它们仅在你的评分方案不包含分值、或你想生成一个评分方案时才有意义。\n\n分数规则：对每个任务，要么给所有直接子任务分配分数且其总和等于上级任务的总分，要么都不分配。如果你不给子任务分配分数而只给一个总分，AI 会在生成评分方案时自动分配。",
    "textCutoff": "题目的文本不完整",
    "missingInformation": "信息缺失",
    "imageUnreadable": "图片无法读取",
    "task": "题目",
    "mainTasks_one": "我识别出了 {{mainCount}} 个主题目。",
    "mainTasks_other": "我识别出了 {{mainCount}} 个主题目。",
    "mainAndSubTasks_one": "我识别出了 {{mainCount}} 个主题目和 {{subCount}} 个子题目。",
    "mainAndSubTasks_other": "我识别出了 {{mainCount}} 个主题目和 {{subCount}} 个子题目。",
    "intro": "### 我识别出了以下题目结构：\n\n{{countText}}",
    "problemsIntro": "\n\n在题目识别过程中出现以下问题：{{warnings}}。请查看画布中的不确定项，根据需要进行编辑，然后通过按钮或在聊天中确认。",
    "uncertaintyIntro": "\n\n在题目识别中，{{labels}} 处存在不确定性。请查看画布中的不确定项，根据需要进行编辑，然后通过按钮或在聊天中确认。",
    "success": "\n\n在题目识别中未出现任何问题。如果愿意，您仍可以在画布中仔细查看，否则请通过按钮或在聊天中确认。"
  },
  "chatMessages": {
    "emptyState": "在下方输入消息以开始对话",
    "newMessage": "新消息",
    "cancel": "取消",
    "send": "发送",
    "edit": "编辑",
    "editInCanvas": "在画布中编辑",
    "confirmed": "已确认",
    "confirm": "确认",
    "confirmAssignment": "确认分配",
    "giveFeedback": "提供反馈",
    "feedbackTitle": "提供反馈",
    "feedbackDescription": "告诉我们如何改进这个回答。",
    "feedbackPlaceholder": "在此输入您的反馈...",
    "feedbackSubmit": "发送反馈",
    "submitAssignmentConfirmation": "我确认页面拆分和学生分配。请继续。",
    "submitStructureConfirmation": "我确认题目结构",
    "studentSubmissions": "学生答卷",
    "masterSolution": "参考答案",
    "gradingScheme": "评分标准",
    "blankExam": "空白试卷",
    "confirmedAssignmentIntro": "已确认的文件分配：",
    "assignmentIntro": "我已将文件分配如下。请检查并确认此分配："
  },
  "AuthModal": {
    "loginError": "电子邮箱或密码错误。",
    "signupFailed": "注册失败。请重试。",
    "passwordMismatch": "密码不匹配。",
    "forgotPasswordProblem": "出现问题。请稍后再试。",
    "waitlistTitle": "您已在候补名单中！",
    "waitlistDesc": "下一阶段开始时我们会立即与您联系。",
    "waitlistInactive": "候补名单目前已关闭。",
    "backToLogin": "返回登录",
    "linkSentTitle": "链接已发送！",
    "linkSentDesc": "知道了",
    "forgotPasswordTitle": "忘记密码？",
    "requestLink": "请求链接",
    "welcomeBack": "欢迎回来",
    "createAccount": "创建账户",
    "emailLabel": "电子邮箱",
    "passwordLabel": "密码",
    "forgotPasswordLink": "忘记密码？",
    "loginButton": "登录",
    "firstNameLabel": "名字",
    "lastNameLabel": "姓氏",
    "schoolLabel": "学校",
    "subjectsLabel": "科目",
    "confirmPasswordLabel": "确认密码",
    "signupButton": "注册",
    "registerHere": "在此注册",
    "loginHere": "在此登录",
    "continueGuest": "不登录继续 →"
  },
  "FeedbackPage": {
    "alerts": {
      "imageTooLarge": "图片 \"{{name}}\" 太大（最大 5MB）。",
      "previewError": "无法为 {{name}} 创建预览。",
      "submitError": "出现了一些问题。请再试一次。"
    },
    "success": {
      "title": "非常感谢您的反馈！",
      "description": "我们已收到您的消息。您的意见对我们每天把 Gradias 做得更好大有帮助。",
      "backButton": "返回试卷"
    },
    "header": {
      "title": "提供反馈"
    },
    "content": {
      "description": "您是否注意到了错误、有个绝妙的想法，或者只是想告诉我们些什么？我们阅读每一条消息！"
    },
    "categories": {
      "title": "关于什么内容？",
      "bug": {
        "title": "错误 / Bug",
        "desc": "某些功能无法正常工作"
      },
      "feature": {
        "title": "想法 / 建议",
        "desc": "一项新功能"
      },
      "general": {
        "title": "其他",
        "desc": "常规反馈"
      }
    },
    "message": {
      "title": "您的消息",
      "placeholder": "请尽可能详细地描述您的需求..."
    },
    "upload": {
      "title": "添加截图（可选）",
      "clickToSelect": "点击选择图片",
      "formatConstraint": "PNG, JPG 格式，每张图片最大 5MB",
      "attachedImages": "已添加的图片",
      "removeImage": "移除图片"
    },
    "submit": {
      "sending": "正在发送...",
      "send": "提交反馈"
    }
  },
  "ConfirmationReplies": {
    "split": {
      "confirmed": "试卷分派和学生人数已成功确认。现在可以启动题目结构的提取。请在聊天中向用户表示感谢，并告知用户题目结构的提取现在即将开始。",
      "pending": "试卷分派和学生人数尚未确认。"
    },
    "structure": {
      "masterAndGrading": "题目结构已成功确认。提取正在后台继续运行。参考答案和评分标准已经上传并正在后台处理。简要感谢用户对题目结构的确认，并告知用户提取正在继续。向其建议开始评分批改。",
      "masterOnly": "题目结构已成功确认。提取正在后台继续运行。参考答案已经上传，但仍缺少评分标准。简要感谢用户对题目结构的确认，并告知用户提取正在继续。向其建议在下一步中创建基于 AI 的评分标准。",
      "gradingOnly": "题目结构已成功确认。提取正在后台继续运行。评分标准已经上传，但仍缺少参考答案。简要感谢用户对题目结构的确认，并告知用户提取正在继续。向其建议创建一个基于 AI 的参考答案。",
      "none": "题目结构已成功确认。提取正在后台继续运行。目前还缺少参考答案。简要感谢用户对题目结构的确认，告知用户提取正在继续，并询问用户在下一步（提取完成后）是由系统生成基于 AI 的参考答案，还是他想通过输入框中的回形针图标重新上传一份参考答案。在回答中提及用户如何上传参考答案，即点击聊天输入框中的回形针图标。"
    },
    "errors": {
      "notConfirmed": "确认标志为 false；无须操作。",
      "missingIdentifiers": "缺少确认所需的标识符。",
      "missingSplitMessage": "错误：未找到关联的拆分确认消息。",
      "missingStructureMessage": "错误：未找到关联的结构确认消息。",
      "structureContentMissing": "错误：无法加载结构确认消息。",
      "splitFailure": "确认拆分时出错。",
      "structureFailure": "确认结构时出错。"
    }
  },
  "toolFallbackDesc": {
    "default": "执行工具步骤",
    "set_metadata": "试卷元数据",
    "create_exam": "立即创建试卷",
    "generate_master_solution": "现在创建参考答案",
    "refine_master_solution": "针对性优化参考答案",
    "generate_grading_scheme": "现在创建评分标准",
    "refine_grading_scheme": "针对性优化评分标准",
    "run_grading_agent": "执行评分批改",
    "set_task_score": "手动设置分数",
    "open_canvas": "打开画布视图",
    "update_open_task_content": "直接更新题目文本",
    "send_assignment_confirmation_message": "发送文件分配确认",
    "process_files": "处理已上传的文件",
    "confirm_split_in_chat": "在聊天中确认分配",
    "confirm_structure_in_chat": "在聊天中确认结构",
    "query_exams": "获取试卷数据",
    "query_submissions": "获取学生答卷",
    "get_available_options": "获取可用选项",
    "get_task_types": "获取题目类型",
    "download_ms_gs": "下载参考答案/评分标准",
    "download_summary_reports": "下载评估报告",
    "save_teacher_memory": "记住偏好",
    "get_teacher_memory": "查找偏好",
    "delete_teacher_memory": "删除偏好",
    "reprocess_errored_submissions": "重新处理错误的提交"
  },
  "Subjects": {
    "math": "数学",
    "physics": "物理",
    "chemistry": "化学",
    "biology": "生物",
    "history": "历史",
    "geography": "地理",
    "english": "英语",
    "german": "德语",
    "french": "法语",
    "spanish": "西班牙语",
    "computer_science": "计算机科学",
    "social_studies": "社会学/政治",
    "other": "其他"
  },
  "ExamNotifications": {
    "newMessage": "新消息"
  },
  "LanguageUseTemplates": {
    "essay": "能力等级 · 表达能力\n\n* 优秀：\n  - 文章结构清晰、逻辑严密，各部分之间衔接有效。\n  - 专业术语运用准确、娴熟。\n  - 引文融入恰当、引入自然，并附有行号出处。\n  - 句法富有变化，风格把握到位，与文学对象相契合。\n  - 语法、拼写和标点几乎没有错误。\n* 良好：\n  - 文章结构条理清晰。\n  - 专业术语运用大体准确。\n  - 引文使用恰当，出处标注正确。\n  - 句法正确且富有变化。\n  - 语法、拼写和标点方面的失误较少。\n* 中等：\n  - 结构可辨识，但并非始终连贯一致。\n  - 专业术语运用尚可，但不总是精确。\n  - 使用了引文，出处大体正确。\n  - 句法大体正确，偶显单调。\n  - 语法、拼写和标点方面的失误不影响理解。\n* 及格：\n  - 结构仅可初步辨识。\n  - 专业术语运用不足或不准确。\n  - 引文运用不一致或出处不完整。\n  - 句法单一，存在较多不确定之处。\n  - 语言准确性有限；理解偶尔受阻。\n* 差：\n  - 表达在很大程度上缺乏结构。\n  - 专业术语大量缺失或使用错误。\n  - 引文缺失或有误。\n  - 语言缺陷明显妨碍理解。\n* 极差：\n  - 表达缺陷严重，文章几乎无法理解。\n  - 未能体现书面文学解读文章的基本要求。",
    "analysisNonFiction": "能力等级 · 表达能力\n\n* 优秀：\n  - 文章结构清晰、逻辑严密，各部分之间衔接有效。\n  - 专业术语运用准确、娴熟。\n  - 引文融入恰当、引入自然，并附有行号出处。\n  - 句法富有变化，风格把握到位，与文学对象相契合。\n  - 语法、拼写和标点几乎没有错误。\n* 良好：\n  - 文章结构条理清晰。\n  - 专业术语运用大体准确。\n  - 引文使用恰当，出处标注正确。\n  - 句法正确且富有变化。\n  - 语法、拼写和标点方面的失误较少。\n* 中等：\n  - 结构可辨识，但并非始终连贯一致。\n  - 专业术语运用尚可，但不总是精确。\n  - 使用了引文，出处大体正确。\n  - 句法大体正确，偶显单调。\n  - 语法、拼写和标点方面的失误不影响理解。\n* 及格：\n  - 结构仅可初步辨识。\n  - 专业术语运用不足或不准确。\n  - 引文运用不一致或出处不完整。\n  - 句法单一，存在较多不确定之处。\n  - 语言准确性有限；理解偶尔受阻。\n* 差：\n  - 表达在很大程度上缺乏结构。\n  - 专业术语大量缺失或使用错误。\n  - 引文缺失或有误。\n  - 语言缺陷明显妨碍理解。\n* 极差：\n  - 表达缺陷严重，文章几乎无法理解。\n  - 未能体现书面文学解读文章的基本要求。",
    "genericGroup": "能力等级 · 表达能力\n\n* 优秀：\n  - 文章结构清晰、逻辑严密，各部分之间衔接有效。\n  - 专业术语运用准确、娴熟。\n  - 引文融入恰当、引入自然，并附有行号出处。\n  - 句法富有变化，风格把握到位，与文学对象相契合。\n  - 语法、拼写和标点几乎没有错误。\n* 良好：\n  - 文章结构条理清晰。\n  - 专业术语运用大体准确。\n  - 引文使用恰当，出处标注正确。\n  - 句法正确且富有变化。\n  - 语法、拼写和标点方面的失误较少。\n* 中等：\n  - 结构可辨识，但并非始终连贯一致。\n  - 专业术语运用尚可，但不总是精确。\n  - 使用了引文，出处大体正确。\n  - 句法大体正确，偶显单调。\n  - 语法、拼写和标点方面的失误不影响理解。\n* 及格：\n  - 结构仅可初步辨识。\n  - 专业术语运用不足或不准确。\n  - 引文运用不一致或出处不完整。\n  - 句法单一，存在较多不确定之处。\n  - 语言准确性有限；理解偶尔受阻。\n* 差：\n  - 表达在很大程度上缺乏结构。\n  - 专业术语大量缺失或使用错误。\n  - 引文缺失或有误。\n  - 语言缺陷明显妨碍理解。\n* 极差：\n  - 表达缺陷严重，文章几乎无法理解。\n  - 未能体现书面文学解读文章的基本要求。",
    "materialBasedEssay": "基于材料的写作（论证性/信息性文章写作）\n\n内容表现与材料运用（理解能力/文章结构）：\n* 引言简洁，能激发读者兴趣并引出主题（避免使用套话式过渡）。\n* 文章结构合理，符合所要求文体（如评论、随笔、文章）的各构成要素。\n* 开篇即清晰勾勒出主题及相关问题。\n* 必要时对重要基础概念作恰当解释。\n* 充分考虑所提供的全部材料，并将其恰当、内容准确地融入文章。\n* 转述他人观点时保持透明（正确引用、转述并标明出处）。\n* 清晰区分事实陈述、论证与个人评价。\n* 论证广泛且层次分明（兼顾主题的不同方面及可能的反驳观点）。\n* 各项论据对目标读者具有说服力，结构清晰，阐述充分，并有证据/例证支持。\n* 除材料中的论据外，还提出独立见解及个人专业知识。\n* 论证在结尾归纳为结论，必要时可展望未来。\n\n语言表现与文本组织（表达能力）：\n* 语言表达符合所要求的文体，语言清晰精准，表述具有独立性。\n* 词汇运用、专业术语掌握及功能性文风精准、有层次且风格恰当。\n* 句式简明、富于变化且语法结构复杂。\n* 语法、拼写和标点方面的规范性错误不影响阅读流畅性。",
    "literaryAnalysisPoetry": "表达能力\n* 1. 考生对文章的组织连贯、条理清晰、逻辑严密、思路明确：\n  - 各分项任务在完成过程中的权重分配得当\n  - 全文结构清晰，权重分配合理\n  - 各写作步骤之间衔接连贯\n  - 句与句之间思路连贯\n* 2. 考生的表述符合专业语言及学科方法上的要求：\n  - 区分行为层面与元层面\n  - 描述性、阐释性与评价性表述之间有理有据地相互关联\n  - 在恰当语境中运用专业术语\n  - 注意时态的正确使用\n  - 正确转述间接引语（情态）\n* 3. 考生通过恰当、正确的引用来支撑论述：\n  - 合理运用完整或节选引文以支撑论点\n* 4. 考生的表达在一般语言层面精准、风格把握稳健、概念表述有层次：\n  - 客观、克制的写作风格\n  - 书面语体\n  - 具有抽象概念表达能力\n* 5. 考生的措辞在词汇和句法上稳健、富于变化且复杂（同时保持清晰）。\n* 6. 考生书写语言规范正确。"
  },
  "LatexEditor": {
    "insertFormula": "公式",
    "insertFormulaHint": "在光标位置插入新公式",
    "switchToRawLatex": "切换到原始 LaTeX",
    "switchToVisualEditor": "切换到可视化编辑器",
    "naturalLanguageHint": "用自然语言描述此公式",
    "naturalLanguagePlaceholder": "例如“0到10的x²积分”",
    "naturalLanguageError": "翻译失败，请重试。",
    "insert": "插入",
    "removeFormula": "删除公式",
    "cancel": "取消"
  },
  "StudentExam": {
    "loading": "正在加载试卷…",
    "examFallbackTitle": "试卷",
    "classLabel": "{{class}} 班",
    "namePlaceholder": "你的姓名",
    "answeredCount": "已作答 {{answered}} / {{total}}",
    "submit": "提交",
    "signInRequiredTitle": "需要登录",
    "signInRequiredBody": "请登录后作答这份试卷。",
    "signInAction": "前往登录",
    "unavailableTitle": "不可用",
    "submittedTitle": "已提交",
    "submittedBody": "你的答案已保存，等待批改。",
    "errors": {
      "loadFailed": "无法加载试卷。",
      "notFound": "该试卷不存在。",
      "notSignedIn": "尚未登录。",
      "noAccess": "未找到试卷，或没有访问权限。",
      "noTasks": "该试卷还没有题目。",
      "uploadedExam": "该试卷是上传的而非创建的，因此无法在线作答。",
      "studentsOnly": "在线填写仅适用于学生账号。",
      "renderFailed": "无法显示试卷。",
      "unreadableAnswers": "无法读取答案。",
      "submitFailed": "提交失败。"
    },
    "canvas": {
      "undo": "撤销",
      "clear": "清除",
      "pen": "画笔",
      "eraser": "橡皮擦",
      "redo": "重做",
      "zoom": "放大绘制",
      "zoomClose": "关闭放大视图",
      "penWidth": "笔画粗细 {{width}}"
    }
  }
}
